// extracted by mini-css-extract-plugin
module.exports = {"tileOverlay":"sy","defaultTileOverlay":"sz","defaultRentalTileOverlay":"sA","tileOverlayOn":"sB","tileOverlayOff":"sC","addRemoveButton":"sD","circularFrame":"sE"};